import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import LoadingSpinner from '../ui/LoadingSpinner';
import AbEnvironment from '../auth/AbEnvironment';
import SubscriptionOrderFetch from '../auth/SubscriptionOrderFetch';

const abEnvironment = new AbEnvironment();

// Verify needs to show spinner, call the invitetoken API with the user parm
class Verify extends Component {

  getRedirectLink(usertok, thisPage)
  {
    const { callPartnerApi } = this.props.auth;
  
    let theLink = '';
    let hasSubscriptionOrder = false;

    return new Promise(function(resolve, reject) {
      callPartnerApi('appbind/invitetoken/' + usertok,
                     'GET',
                     null,
                     true)
      .then(response => {
        return response.json();
      })
      .then(data => {
        abEnvironment.setUserAttribute('email_verified', 'true');
        theLink = data.link;
        return theLink;
      })
      .then(data => {
        let accountId = abEnvironment.getUserAttribute('a_id');

        return SubscriptionOrderFetch.fetch(accountId).toPromise()

      })
      .then(resp => {
        if (resp && resp.allSubscriptionOrderTs) {
          if (resp.allSubscriptionOrderTs.totalCount === 1) {
            hasSubscriptionOrder = true;
          }
        }
        return resp;
      })
      .then(resp => {
        if (hasSubscriptionOrder === true) {
          return thisPage.convertSubscriptionOrder();
        } else {
          return null;
        }          
      })
      .then((resp) => {

        if (resp && resp.data && resp.data.result  && resp.data.result.data && hasSubscriptionOrder) {
          //the response gets saved and the user is redirected then to the SO
          localStorage.setItem('subscriptionOrderComplete', true);
          if (theLink.indexOf('/home') !== -1) {
            let newLink = theLink.substring(0, theLink.indexOf('/home'));
            newLink = newLink + '/subscriptionorder' ;
            theLink = newLink;
          }
        } else {
          //if they come in from vendor landing page....
          let newLink = localStorage.getItem('fromVendorLanding');
          if (newLink) {
            localStorage.removeItem('fromVendorLanding');
            theLink = newLink;
          }
        }
       resolve(theLink);
      })
      .catch(err => {
        // console.log('err');
        if (theLink !== '') {
          //if the link is not empty it means the failure occurred trying to look up subscription order
          //this can happen if the user tries the link again but they are not logged in.
          resolve(theLink);
        } else {
          reject(err);
        }
      });
    });
  }


  convertSubscriptionOrder = () => {
    
    var userId = abEnvironment.getUserAttribute("u_id");
    let accountId = abEnvironment.getUserAttribute('a_id');

    const { callPartnerApi } = this.props.auth;

    return new Promise(function(resolve, reject) {
      let aPjwt = abEnvironment.getPjwt();

      // Call server side process JSON order.
      let payload = {
        operation: "convertSubscriptionOrder3",
        params: {
          pJwt:       aPjwt,
          pAccountId: accountId,
          userId:     userId
        }
      };
  
      callPartnerApi('appbind/generic',
                    'POST',
                    payload)
    
      .then(response => {
        return response.json();
      })
      .then(data => {
        resolve(data);
      })
      .catch(err => {
        // console.log('err');
        reject(err);
      });
    });

  }


  render() {
    const { isAuthenticated } = this.props.auth;
    let thisPage = this;

    let theId = this.props.match.params.id;

    if (isAuthenticated() && abEnvironment.getUserAttribute('email_verified') === 'true') { 
      //this would happen if someone trying to use their verify link again.
      //here we are setting the location to get it to reload itself as
      //the verify hides left nav but home does not.
      window.location = '/home';
    } else {
      Promise.resolve()
      .then(() => {
        return thisPage.getRedirectLink(theId, thisPage);
      })
      .then(redirectLink => {
        window.location = redirectLink;
      })
      .catch(err => {
        return ( <Redirect to='/home' /> );
      });
    }
  
    return (
      <div>
        <LoadingSpinner/>
      </div>
    );
  }
}

export default Verify;